import {useState} from "react";
import styled from "styled-components";
import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";
import {Noimage} from "@yb/ui/desktop/common/Noimage";
import {BlueText} from "../text";

const Wrap = styled.div`
	position: relative;
	z-index: 5;
	display: flex;
	flex: 0 0 975px;
	width: 100%;
	border: 2px solid var(--emp-color);
	box-sizing: border-box;
	input {
		flex: 0 0 860px;
		width: 100%;
		height: 56px;
		line-height: 56px;
		padding: 0 10px;
		border: 0 none;
		font-size: var(--medium-size);
		font-family: "PT-medium";
		color: var(--emp-color);
		vertical-align: middle;
		box-sizing: border-box;
	}
`;

const AutoButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 47px;
	height: 56px;
	background: #fff;

	&::before {
		display: block;
		width: 8px;
		height: 8px;
		margin-top: 1px;
		background: url(${SpriteImage}) -178px 0 / 300px 300px;
		content: "";
	}
`;

const SearchIcon = styled.button`
	position: relative;
	width: 63px;
	height: 56px;
	background-color: #fff;
	&::before {
		position: absolute;
		top: 50%;
		left: 50%;
		display: block;
		width: 24px;
		height: 24px;
		background: url(${SpriteImage}) -110px -26px / 400px 400px;
		transform: translate(-50%, -50%);
		content: "";
	}
	&:after {
		position: absolute;
		top: 50%;
		left: 0;
		display: block;
		width: 1px;
		height: 28px;
		background-color: var(--line-color);
		transform: translateY(-50%);
		content: "";
	}
`;

const AutoSearchWrap = styled.div`
	display: flex;
	position: absolute;
	top: 56px;
	left: -2px;
	width: 975px;
	min-height: 440px;
	background: #fff;
	border: 2px solid var(--emp-color);
	box-sizing: border-box;

	&:after {
		position: absolute;
		top: 0;
		left: 341px;
		display: block;
		width: 1px;
		height: 100%;
		background-color: var(--line-color);
		content: "";
	}
`;

const AutoSearchList = styled.ul`
	display: flex;
	flex-direction: column;
	flex: 0 0 341px;
	margin-top: 10px;
	li {
		flex: 0 0 35px;
		padding: 0 10px;
		&:hover {
			background-color: #f3f3f3;
		}
		a {
			display: flex;
			align-items: center;
			gap: 5px;
			width: 100%;
			height: 100%;
		}
	}
`;

const CatalogList = styled.ul`
	display: flex;
	flex: 1 1 auto;
	gap: 20px;
	margin: 40px 20px;
`;

const CatalogListItem = styled.li`
	width: 285px;
`;

const CatalogListText = styled.div`
	padding: 15px 15px 10px 15px;
`;

const ProdTitle = styled.h5`
	min-height: 48px;
	max-height: 48px;
	margin-bottom: 13px;
	font-size: 16px;
	font-family: "PT-medium";
	color: var(--emp-color);
`;

const ProdDate = styled.span`
	display: flex;
	gap: 5px;
	line-height: 1;
	margin: -5px 0 26px 0;
	color: var(--default-color);
`;

const ProdPrice = styled.span`
	position: relative;
	display: block;
	text-align: right;

	> span {
		line-height: 1;
		font-size: var(--basic-size);
		color: var(--red-color);
		em {
			font-size: 20px;
		}
	}
`;

const ProdButton = styled.button`
	position: absolute;
	top: -6px;
	right: 0;
	display: block;
	width: 110px;
	height: 38px;
	line-height: 38px;
	background: #eee;
	font-size: var(--basic-size);
	color: var(--emp-color);
`;

const SearchInputBox = () => {
	const [show, setShow] = useState(false);
	return (
		<Wrap>
			<input />
			<AutoButton onClick={() => setShow(!show)}>
				<span>자동완성 여닫기</span>
			</AutoButton>
			<SearchIcon>
				<span>검색하기</span>
			</SearchIcon>
			{show && (
				<AutoSearchWrap>
					<AutoSearchList>
						<li>
							<a href="#">
								<BlueText>일본</BlueText>
								교토 자유여행
							</a>
						</li>
						<li>
							<a href="#">
								<BlueText>일본</BlueText>동경 자유여행
							</a>
						</li>
						<li>
							<a href="#">
								<BlueText>일본</BlueText>삿포로 자유여행
							</a>
						</li>
						<li>
							<a href="#">
								<BlueText>일본</BlueText>오사카 자유여행
							</a>
						</li>
						<li>
							<a href="#">
								<BlueText>일본</BlueText>자유여행
							</a>
						</li>
					</AutoSearchList>
					<CatalogList>
						<CatalogListItem>
							<Noimage
								width="285px"
								height="195px"
								src="https://dimgcdn.ybtour.co.kr/TN/19/19913e6676b513ad88b539597724d5ad.tn.410x280.jpg"
								alt="상품 이미지"
							/>
							<CatalogListText>
								<ProdTitle>시드니 + 포트스테판 6일 #시드니동물원 #하버디너크루즈</ProdTitle>
								<ProdDate>
									<span>출발기간</span>
									<span>2024.03.01 ~ 2024.03.06</span>
								</ProdDate>
								<ProdPrice>
									{/* <span>
								<em>1,499,000</em> 원~
							</span> */}
									<ProdButton>상품보기</ProdButton>
								</ProdPrice>
							</CatalogListText>
						</CatalogListItem>
						<CatalogListItem>
							<Noimage
								width="285px"
								height="195px"
								src="https://dimgcdn.ybtour.co.kr/TN/19/19913e6676b513ad88b539597724d5ad.tn.410x280.jpg"
								alt="상품 이미지"
							/>
							<CatalogListText>
								<ProdTitle>시드니 + 포트스테판 6일 #시드니동물원 #하버디너크루즈</ProdTitle>
								<ProdDate>
									<span>출발기간</span>
									<span>2024.03.01 ~ 2024.03.06</span>
								</ProdDate>
								<ProdPrice>
									{/* <span>
								<em>1,499,000</em> 원~
							</span> */}
									<ProdButton>상품보기</ProdButton>
								</ProdPrice>
							</CatalogListText>
						</CatalogListItem>
					</CatalogList>
				</AutoSearchWrap>
			)}
		</Wrap>
	);
};

export default SearchInputBox;
